import BigPanda from './BigPanda';
import DataDog from './DataDog';
import PagerDuty from './PagerDuty';

const PartnerFields = {
  BigPanda,
  DataDog,
  PagerDuty,
};

export default function getDefaultFields(partnerName) {
  return PartnerFields[partnerName];
}
